<div class="page">
	@if (hasDoneAnything()) {
	<div class="page-header">
		<app-navbar [backFunction]="back" [showBackButton]="true" />
	</div>
	}

	<div class="page-content align-items-center justify-content-center">
		<div class="page-content-row">
			<div class="d-flex justify-content-between buttons-bar"></div>
			<div
				class="survey-image d-flex justify-content-center align-items-center mb-3"
			>
				<img alt="Survey Image" [src]="'assets/images/surveys/apv.svg'">
			</div>
			<h4>{{ "wpa.introduction-header" | translate }}</h4>
			<p [innerHTML]="'wpa.introduction-text' | translate"></p>
			<div class="mb-4 fw-bold">
				{{ "estimated_time" | translate }} {{ "5-10" }}
				{{ "Minutes" | translate }}
			</div>
			@if (!isLoading()) {
			<div class="d-flex justify-content-center">
				@if (hasBothApvAndScreening() && !apvOnly()) {
				<div
					class="d-flex flex-row gap-3 align-items-center justify-content-center"
				>
					<button class="btn btn-primary btn-circle" (click)="handleWpaAndHs()">
						{{ "APV_Decision_ALL" | translate }}
					</button>
					<button class="btn btn-primary btn-circle" (click)="handleWpaOnly()">
						{{ "APV_Decision_APV" | translate }}
					</button>
				</div>
				} @else {
				<button class="btn btn-primary btn-circle" (click)="handleStart()">
					{{ "start" | translate }}
				</button>
				}
			</div>
			}
		</div>
	</div>
</div>
